"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCTAs = void 0;
var getCTAs = function (_a) {
    var isSmart = _a.isSmart, isNonComms = _a.isNonComms, hasRecentManualReading = _a.hasRecentManualReading, isOnboarding = _a.isOnboarding, isInOMRWindow = _a.isInOMRWindow;
    if (isOnboarding && !isInOMRWindow) {
        return ['OnboardingNotInOMRWindow'];
    }
    if (isOnboarding && isInOMRWindow && hasRecentManualReading) {
        return ['SubmitOMRReadingAgain'];
    }
    if (isOnboarding && isInOMRWindow) {
        return ['SubmitOMRReading'];
    }
    if (!isSmart) {
        return ['SubmitReading', 'ViewHistory'];
    }
    if (isSmart && isNonComms) {
        return ['SubmitReading', 'ViewHistory'];
    }
    //isSmart && !isNonComms
    return ['ViewHistory'];
};
exports.getCTAs = getCTAs;
